import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import visitorDataAccess from "src/dataAccess/Visitor/visitorDataAccess";
import { IListType } from "../store";
import { ModuleNameReverseMap } from "src/common/constants";
import { createAbstractBuilder } from "typescript";

export const getVisitorListSuccess = createAction<any>(
  "[Visitor] Get Visitor List Success"
);
export const loadingList = createAction<boolean>("[Visitor] Loading list");
export const GetVisitorList = createAsyncThunk<any, IListType>(
  "[Visitor] Get Visitor List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));
    const result = await visitorDataAccess.getList(parameter).then((res) => {
      console.log(res);
      thunkAPI.dispatch(getVisitorListSuccess(res));
      thunkAPI.dispatch(loadingList(false));
      return res;
    });
    return result;
  }
);
export const DeleteVisitorSuccess = createAction<number[]>(
  "[Visitor] Delete Visitor success"
);
export const saveVisitorListSuccess = createAction<any>(
  "[Visitor] Save Visitor Success"
);

export const saveVisitorListAsync = createAsyncThunk<
  any,
  { visitorId: any; data: any; visitorList: Array<any> }
>("[Visitor] Save Visitor", async (parameter, thunkAPI) => {
  const { visitorId, data, visitorList } = parameter;
  thunkAPI.dispatch(loadingList(true));
  console.log(visitorId);
  var updatedVisitorList;
  if (visitorId == "edit") {
    let copyVisitorList = [...visitorList];
    updatedVisitorList = (copyVisitorList ?? []).map((item, index) => {
      let copyItem = { ...item };

      if (copyItem.id == data.id) {
        copyItem = data;
      }
      return copyItem;
    });
  } else {
    let copyVisitorList = [...visitorList];
    updatedVisitorList = [...copyVisitorList, data];
  }
  thunkAPI.dispatch(saveVisitorListSuccess(updatedVisitorList));
  thunkAPI.dispatch(loadingList(false));
  return data;
});
export const getVisitorLogListSuccess = createAction<any>(
  "[VisitorLog] Get Visitor Log List Success"
);
export const loadingVisitorLogList = createAction<boolean>(
  "[VisitorLog] Loading list"
);

export const GetVisitorLogList = createAsyncThunk<any, IListType>(
  "[VisitorLog] Get Visitor Log List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingVisitorLogList(true));
    const result = await visitorDataAccess.getVisitorLogList(parameter).then((res) => {
      thunkAPI.dispatch(getVisitorLogListSuccess(res));
      thunkAPI.dispatch(loadingVisitorLogList(false));
      return res;
    });
    return result;
  }
);

export const getCompletedVisitorListSuccess = createAction<any>(
  "[Visitor] Get Completed Visitor List Success"
);
export const loadingCompletedVisitorList = createAction<boolean>(
  "[Visitor] Loading Completed list"
);

export const GetCompletedVisitorList = createAsyncThunk
  <any,
    IListType & { type: string }
  >(
    "[Visitor] Get Completed Visitor List",
    async (parameter, thunkAPI) => {
      thunkAPI.dispatch(loadingCompletedVisitorList(true));
      const moduleName =
        parameter.type === "Contractors"
          ? ModuleNameReverseMap["Completed Contractors"]
          : ModuleNameReverseMap["Completed Visitors"];
      const result = await visitorDataAccess
        .getCompletedVisitorList(parameter, moduleName)
        .then((res) => {
          thunkAPI.dispatch(getCompletedVisitorListSuccess(res));
          thunkAPI.dispatch(loadingCompletedVisitorList(false));
          return res;
        });
      return result;
    }
  );